/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';
import YouTube from 'react-youtube';
// import ReactPlayer from 'react-player';

/* Internal Imports */
/* Components */
import LiteYouTubeEmbed from '@components/Embeds/YoutubeEmbed';
import { getEmbedUrl } from '@components/Utility/utils';
import MidContainer from '@Layout/MidContainer';
import RitualEmbed from '@lb/components/Embeds/RitualEmbed';

/* Services */
/* Styles */
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

/**
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for Section
 * @param sectionContent.margin
 * @param sectionContent.width
 * @param sectionContent.pxBase
 * @returns {ReactElement} MediaEmbed component
 */
const MediaEmbed = ({ sectionContent, margin, width }) => {
  const [vidVis, setVidVis] = useState(true);
  const [opts, setOpts] = useState({});
  // const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    setOpts({
      height: document.getElementById('msr-vid')?.clientHeight,
      // height: '315',
      width: '100%',
      playerVars: {
        autoplay: 1,
      },
    });
  }, [global?.window]);

  const onReady = event => {
    event.target.playVideo();
  };
  let url = sectionContent?.embedUrl || sectionContent?.url;
  let splitUrl = url?.split('&');
  url = splitUrl[0];
  if (sectionContent?.image?.url) {
    return (
      <>
        {sectionContent.style === 'lb-inline-video' ? (
          <MidContainer w={width || '100%'}>
            <Box maxW="1330px" margin="auto">
              <Box
                backgroundSize="100% 50%"
                backgroundPosition="center"
                display="grid"
                placeItems="center"
                position="relative"
                _before={{
                  content: "''",
                  width: '100%',
                  position: 'absolute',
                  height: '50%',
                  background:
                    'linear-gradient(0deg, #D5CAAE 0%, rgba(255, 255, 255, 0) 100%)',
                  backgroundBlendMode: 'multiply',
                  backgroundPosition: 'center',
                }}
                px={{ base: '20px', md: '15%' }}
              >
                <Box
                  border={{
                    base: '8.04703px solid #BC4034',
                    md: '22.04703px solid #BC4034',
                  }}
                  backgroundImage={sectionContent?.image?.url}
                  backgroundSize="cover"
                  backgroundColor="#000"
                  backgroundRepeat="no-repeat"
                  backgroundPosition="center"
                  width="100%"
                  // maxW="900px"
                  position="relative"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDir="column"
                  cursor="pointer"
                  onClick={() => setVidVis(!vidVis)}
                  // onClick={onOpen}
                  overflow="hidden"
                  height={{ base: '194px', md: '530px' }}
                  m={margin || '0 auto 30px auto'}
                  id="msr-vid"
                >
                  {' '}
                  {vidVis && (
                    <Box maxW="100%" w="full">
                      <YouTube
                        videoId={getEmbedUrl(url)}
                        onReady={onReady}
                        opts={opts}
                        loading="lazy"
                      />{' '}
                    </Box>
                  )}
                </Box>
              </Box>
              {/* <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
                <ModalOverlay bg="rgba(0, 0, 0, 0.7)" />
                <ModalContent
                  p={0}
                  m="0"
                  maxW={{ base: '257px', md: '992px' }}
                  maxH={{ base: '603px', md: '587px' }}
                > */}
              {/* <ModalHeader>Modal Title</ModalHeader> */}
              {/* <ModalCloseButton
                    bg="#FFFFFF"
                    color="#ffffff"
                    zIndex="20"
                    rounded="full"
                    _hover={{ bg: '#ffffff' }}
                    display={{ base: 'none', md: 'flex' }}
                  /> */}
              {/* <ModalBody p={0} m="0" w="100%" position="relative"> */}
              {/* <Box
                      pos={{ base: 'absolute', md: 'static' }}
                      left="50%"
                      right="50%"
                      transform={{ md: 'none', base: 'translate(-50%, -50%)' }}
                      display={{ base: 'flex', md: 'block' }}
                      justifyContent={{ base: 'center' }}
                      alignItems={{ base: 'center' }}
                    > */}
              {/* <Box
                        bg="#FFFFFF"
                        onClick={onClose}
                        w="32px"
                        h="32px"
                        rounded="full"
                        _hover={{ bg: '#ffffff' }}
                        display={{ base: 'grid', md: 'none' }}
                        placeItems="center"
                        pos="absolute"
                        top="-145px"
                        left="-185px"
                        fontFamily="FedraSansStd-Book"
                        zIndex="10"
                        cursor="pointer"
                      > */}
              {/* x */}
              {/* </Box>
                      <YouTube
                        videoId={getEmbedUrl(
                          sectionContent?.url || sectionContent?.embedUrl
                        )}
                        onReady={onReady}
                        opts={opts}
                        loading="lazy"
                        className={styles.RitualEmbed}
                      />{' '} */}
              {/* </Box> */}
              {/* </ModalBody> */}
              {/* </ModalContent> */}
              {/* </Modal> */}
            </Box>
          </MidContainer>
        ) : (
          <Box mb={{ base: '20px', md: '40px' }}>
            <RitualEmbed sectionContent={sectionContent} />
          </Box>
        )}
      </>
    );
  }

  // let pb = '56.25%';
  // if (sectionContent?.source === 'soundcloud') {
  //   pb = '17%';
  // } else {
  //   pb = '22%';
  // }

  if (sectionContent.style === 'lb-inline-video') {
    return (
      <MidContainer w={width || '100%'}>
        <Box maxW="1330px" margin="auto">
          <Box
            backgroundSize="100% 50%"
            backgroundPosition="center"
            display="grid"
            placeItems="center"
            position="relative"
            _before={{
              content: "''",
              width: '100%',
              position: 'absolute',
              height: '50%',
              background:
                'linear-gradient(0deg, #D5CAAE 0%, rgba(255, 255, 255, 0) 100%)',
              backgroundBlendMode: 'multiply',
              backgroundPosition: 'center',
            }}
            px={{ base: '20px', md: '15%' }}
          >
            <Box
              border={{
                base: '8.04703px solid #BC4034',
                md: '22.04703px solid #BC4034',
              }}
              backgroundImage={sectionContent?.image?.url}
              backgroundSize="cover"
              backgroundColor="#000"
              backgroundRepeat="no-repeat"
              backgroundPosition="center"
              width="100%"
              // maxW="900px"
              position="relative"
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDir="column"
              cursor="pointer"
              // onClick={onOpen}
              overflow="hidden"
              height={{ base: '194px', md: '530px' }}
              m={margin || '0 auto 30px auto'}
              id="msr-vid"
            >
              {' '}
              {vidVis && (
                <Box maxW="100%" w="full">
                  <LiteYouTubeEmbed
                    id={getEmbedUrl(sectionContent?.embedUrl)}
                    embedUrl={getEmbedUrl(sectionContent?.embedUrl)}
                    cookie
                  />
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </MidContainer>
    );
  }

  return <RitualEmbed sectionContent={sectionContent} />;
};

export default MediaEmbed;
